import * as types from './types';

export const state = {
  openCategories: [],
  isVisible: false,
};

export const mutations = {
  [types.SET_VISIBLE](state, isVisible) {
    state.isVisible = isVisible;
  },
  [types.TOGGLE_CATEGORY](state, category) {
    const index = state.openCategories.lastIndexOf(category.id);

    if (index !== -1) {
      state.openCategories = state.openCategories.filter(id => category.id !== id);
      return;
    }

    state.openCategories.push(category.id);
  },
  [types.CLOSE_CATEGORIES](state) {
    state.openCategories = [];
  },
};



// WEBPACK FOOTER //
// ./src/screens/Class/ClassSidebar/store/mutations.js